import { RootState } from '../Store';

export const selectIsProfileMenuOpen = (state: RootState) =>
  state.common.isProfileMenuOpen;
